type Area = 'local' | 'session';

/** Web Storage mit Fehlerschutz – im Privatmodus oder bei gesperrtem Speicher werfen die Zugriffe. */
function area(which: Area): Storage {
  return which === 'local' ? window.localStorage : window.sessionStorage;
}

export function readJson<T>(which: Area, key: string): T | null {
  try {
    const raw = area(which).getItem(key);
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

export function writeJson(which: Area, key: string, value: unknown): void {
  try {
    if (value === null || value === undefined) area(which).removeItem(key);
    else area(which).setItem(key, JSON.stringify(value));
  } catch {
    // Speichern ist nur Komfort – die App funktioniert auch ohne.
  }
}
